import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card } from '@material-ui/core';
import SimpleRadio from "./SimpleRadio";
import StandaloneRadio from "./StandaloneRadio";
import PlacingRadioLabel from "./PlacingRadioLabel";

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '3px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
    },
    cardBody: {
        height: '100%'
    }
}));

function RadioComp() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">Radio buttons</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Basic Radio Buttons
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <SimpleRadio />
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Standalone Radio Button
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <StandaloneRadio />
                        </div>
                    </Card>
                </Grid>

            </Grid>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Label Placement
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <PlacingRadioLabel />
                        </div>
                    </Card>
                </Grid>

            </Grid>

        </div>

    )
}

export default RadioComp
